import { Badge, DataGridLeafColumn } from '@ibsys/kit';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { BitrixTouchSendItem } from '@/entities/integrations';
import { formatHumanDate } from '@/shared/lib';

/** Значения нет — ячейка остаётся пустой */
const EMPTY_CELL = '';

/**
 * Колонки перечня заведённых касаний: диалог, исход попытки с отбором по нему, ответ Bitrix24,
 * причина неудачи и время попыток.
 */
export const useBitrixTouchSendColumns = (): DataGridLeafColumn<BitrixTouchSendItem>[] => {
  const { t, i18n } = useTranslation(['integrations']);

  return useMemo(
    () => [
      {
        id: 'conversationId',
        header: t('integrations:bitrixTouch.journal.conversationId'),
        accessor: 'conversationId',
        size: 120,
      },
      {
        id: 'status',
        header: t('integrations:bitrixTouch.journal.status'),
        size: 140,
        enableFiltering: true,
        filter: {
          type: 'select',
          options: [
            { value: 'sent', label: t('integrations:bitrixTouch.journal.statusSent') },
            { value: 'error', label: t('integrations:bitrixTouch.journal.statusError') },
          ],
        },
        cell: ({ row }) => (
          <Badge variant={row.status === 'sent' ? 'primary' : 'destructive'}>
            {row.status === 'sent'
              ? t('integrations:bitrixTouch.journal.statusSent')
              : t('integrations:bitrixTouch.journal.statusError')}
          </Badge>
        ),
      },
      {
        id: 'responseStatus',
        header: t('integrations:bitrixTouch.journal.responseStatus'),
        size: 120,
        cell: ({ row }) => row.responseStatus ?? EMPTY_CELL,
      },
      {
        id: 'error',
        header: t('integrations:bitrixTouch.journal.error'),
        size: 320,
        wrap: true,
        cell: ({ row }) => row.error ?? EMPTY_CELL,
      },
      {
        id: 'updatedAt',
        header: t('integrations:bitrixTouch.journal.updatedAt'),
        size: 200,
        cell: ({ row }) => formatHumanDate(i18n, row.updatedAt, { withTime: true }),
      },
    ],
    [t, i18n],
  );
};
